import HttpClassPortalFront from './request-front';

const api = HttpClassPortalFront.getInstance();

export { api };
